// extracted by mini-css-extract-plugin
module.exports = {"likeIcon":"styles_likeIcon__x_2uV","commentBox":"styles_commentBox__2MZ_o"};